import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the configuration state domain
 */

const selectConfigurationDomain = (state) =>
  state.get("configuration", initialState)

/**
 * Other specific selectors
 */
export const makeSelectConfigurationObject = () =>
  createSelector(selectConfigurationDomain, (state) =>
    state.get("configuration")
  )

export const makeSelectIsLoadingConfiguration = () =>
  createSelector(selectConfigurationDomain, (state) =>
    state.get("isLoadingConfiguration")
  )
/**
 * Default selector used by Configuration
 */

const makeSelectConfiguration = () =>
  createSelector(selectConfigurationDomain, (substate) => substate.toJS())

export default makeSelectConfiguration
export { selectConfigurationDomain }
